var React = require('react');

function Git90 (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1 0C1 17 1 17 18 17","stroke":"#B1B5C4"}));
}

Git90.defaultProps = {"width":"18","height":"18","viewBox":"0 0 18 18","fill":"none"};

module.exports = Git90;

Git90.default = Git90;
